export default [
  {
    path: '/docentes-seguimiento-empresa',
    name: 'docentes-seguimiento-empresa',
    component: () => import('@/views/docentes/seguimiento/layouts/ControlPagoDocentePorEmpresaPage.vue'),
  },
  {
    path: '/docentes-seguimiento-sede',
    name: 'docentes-seguimiento-sede',
    component: () => import('@/views/docentes/seguimiento/layouts/ControlDetalladoPagoDocentePorSedePage.vue'),
  },
];
